<template>
    <div class="pub-btn" @click="addTopic">
        <span class="icon-publish"></span>
        <span class="pub-info">发布帖子</span>
    </div>
</template>
<style lang="less">
    @import '../assets/less/components/publishBtn.less';
</style>
<script>
export default {
    methods: {
        addTopic() {
            this.$emit('add');
        }
    }
};
</script>